export const DeliveryRoutes = (): Array<string> => ([
  'PO',
'IM',
'IV',
'Subcutaneous',
'Inhalation',
'Topical',
'Transdermal',
'Sublingual',
'Buccal',
'PR',
'PV',
'Intra-ocular (bilateral)',
'Intra-ocular (left)',
'Intra-ocular (right)',
'Intra-aural (bilateral)',
'Intra-aural (left)',
'Intra-aural (right)',
'Intra-nasal (bilateral)',
'Intra-nasal (left)',
'Intra-nasal (right)',
]);

export const MedicationFrequency = (): Array<string> => ([
  'daily',
  'bd',
  'tds',
  'qid',
  '5 times/day',
  '4 hourly',
  '6 hourly',
  '8 hourly',
  '12 hourly',
  'nocte',
  'mane',
  'stat',
  'prn',
  'weekly',
  'fortnightly',
  'monthly',
].sort((a, b) => a.localeCompare(b)));

export const DosageUnits = (): Array<string> => ([
  'g',
  'mg',
  'ug',
  'ml',
  'units',
  'mcg',
  'capsule',
  'drops',
  'sachet',
  'spray',
  'tablet',
].sort((a, b) => a.localeCompare(b)));

